import { render, staticRenderFns } from "./saleSubmenu.vue?vue&type=template&id=e29cf064&"
import script from "./saleSubmenu.vue?vue&type=script&lang=ts&"
export * from "./saleSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports